import React, { useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import ChartStyle from "styles/ChartStyle";
import { chartLineWidth } from "styles/variables";
import ChartConfig from "utils/ChartConfig";
import * as V from 'styles/variables';

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    marginTop: 16,
    marginLeft: 16,
    width: "100%",
    display: "block",
    position: "relative",
  },
  chartNote: {
    position: "absolute",
    top: -16,
    right: 48,
    fontSize: 12,
    color: "#666",
    padding: "4px 8px",
    borderRadius: 4,
    zIndex: 10,
    pointerEvents: "none",
    whiteSpace: "nowrap",
  },
}));

const LineChartPictreePhotoShoot = ({
  legend,
  lblSaveImage,
  xAisData,
  seriesData,
  chartType,
  chartConfig,
  yAxis,
  pictreeChartSize,
  colorValue,
}) => {
  const classes = useStyles();
  const [seriesType, setSeriesType] = useState(chartType);
  const [chartData, setChartData] = useState([]);
  const [color, setColorArray] = useState([]);
  const [stackState, setStackState] = useState("");
  const [zoomStart, setZoomStart] = useState(0);
  const [zoomEnd, setZoomEnd] = useState(100);

  useEffect(() => {
    echarts.registerTheme("BarChartTheme", ChartStyle);
  }, []);

  useEffect(() => {
    let eachChartSeries = {},
      seriesDataArray = [],
      colorArray = colorValue;
    _.forOwn(seriesData, function (value, key) {
      _.forOwn(value, function (value2, key2) {
        if (key2 !== "date") {
          const displayName =
            (chartConfig && chartConfig[key2]) !== undefined
              ? chartConfig[key2]
              : key2;
          eachChartSeries.name = displayName;
          eachChartSeries.type = key2.indexOf("count") !== -1 ? "line" : "bar";
          if (key2 === "unique" || key2 === "newUser") {
            eachChartSeries.yAxisIndex = 1;
          }
          eachChartSeries.data = value2;
          eachChartSeries.lineStyle = { width: chartLineWidth };
          eachChartSeries.symbolSize =
            seriesData[0]["date"].length > 60 ? 4 : 8;
          eachChartSeries.barGap = 0;
          eachChartSeries.barMaxWidth = 20;
          seriesDataArray.push(eachChartSeries);
          eachChartSeries = {};
        }
      });
    });
    setChartData(seriesDataArray);
    setColorArray(colorArray);
  }, [seriesData, seriesType]);

  const magicTypeChanged = (param) => {
    if (param.currentType === "stack") {
      setStackState("__ec_magicType_stack__");
    } else if (param.currentType === "tiled") {
      setStackState(null);
    } else {
      setSeriesType(param.currentType);
    }
  };

  const dataZoomChanged = (param) => {
    setZoomStart(param.batch[0]["start"]);
    setZoomEnd(param.batch[0]["end"]);
  };

  const onEvents = {
    magictypechanged: magicTypeChanged,
    datazoom: dataZoomChanged,
  };

  const yAxisValue = yAxis
    ? yAxis
    : [
        {
          type: "value",
          name: "撮影基数",
          alignTicks: true,
          axisLine: {
            show: true,
          },
          axisLabel: {
            formatter: "{value}",
          },
        },
        {
          type: "value",
          name: "撮影者数",
          alignTicks: true,
          axisLine: {
            show: true,
          },
          axisLabel: {
            formatter: "{value}",
          },
        },
      ];

  return (
    <div className={classes.chartContainer}>
      <ReactEcharts
        option={{
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
            },
          },
          grid: {
            left: 64,
            top: 72,
            right: 48,
            bottom: 32,
          },
          legend: {
            show: true,
            left: "center",
            top: 4,
            width: "85%",
            itemGap: 12,
            data: Array.isArray(legend) && legend.length > 0
              ? legend
              : (chartData || []).map(s => s.name).filter(Boolean),
          },
          toolbox: {
            show: false,
            feature: {
              magicType: {
                show: false,
                type: ["bar", "line"],
                title: {
                  line: "Line",
                  bar: "Bar",
                  stack: "Stack",
                  tiled: "Side by Side",
                },
                icon: {
                  line: "image://../../static/images/font-icon/line-chart.svg",
                  bar: "image://../../static/images/font-icon/bar-chart.svg",
                },
              },
              saveAsImage: {
                show: true,
                title: "Save",
                name: lblSaveImage,
                icon: "image://../../static/images/font-icon/save-chart.svg",
              },
            },
          },
          xAxis: {
            type: "category",
            data: xAisData,
          },
          yAxis: yAxisValue,
          dataZoom: [
            {
              disabled: true,
              type: "inside",
              start: zoomStart,
              end: zoomEnd,
            },
          ],
          series: chartData,
          color: color,
        }}
        theme="BarChartTheme"
        notMerge={true}
        lazyUpdate={true}
        onEvents={onEvents}
        style={{ height: "350px", width: "98%" }}
      />
    </div>
  );
};

LineChartPictreePhotoShoot.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pictreeChartSize: state.pictree.chartSize,
});

const mapDispatchToProps = (dispatch) => ({
  //setCurrentModule: (param) => dispatch(setCurrentModule(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(LineChartPictreePhotoShoot));
